import React, {createContext, useReducer} from 'react';
import FormReducer from "./FormReducer";
import InitialState from "./InitialState";

export const GlobalContext = createContext(null);

export const GlobalProvider = ({children}) => {
    const [state, dispatch] = useReducer(FormReducer, InitialState);
    return (
        <GlobalContext.Provider value={{
            state,
            dispatch,
        }}>
            {children}
        </GlobalContext.Provider>
    );
};
